import React, { forwardRef } from 'react';
import { Button, ButtonProps } from '@mui/material';
import { IPageActionBarIconAction } from './interfaces';

type Props = IPageActionBarIconAction & ButtonProps;

export const PageActionBarIconAction = forwardRef<HTMLButtonElement, Props>(
  ({ icon: Icon, onClick, ...buttonProps }, ref) => {
    return (
      <Button
        ref={ref}
        variant="outlined"
        color="default"
        size="small"
        sx={{ minWidth: 0, px: '8px', height: '32px' }}
        onClick={onClick}
        {...buttonProps}
      >
        <Icon
          sx={{
            width: '20px',
            height: '20px',
          }}
        />
      </Button>
    );
  }
);

PageActionBarIconAction.displayName = 'PageActionBarIconAction';
